import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './home-styles/map-view.scss'; // optional, for extra style tweaks

// Fix Leaflet's default icon issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

// Approximate coordinates for your location (Gugai, Salem - 636006)
const position = [11.6643, 78.1460];

const MapView = () => {
  const [interactive, setInteractive] = useState(false);

  const handleEnableMap = () => {
    setInteractive(true);
  };

  return (
    <div className="home-section5">
      <div className="section light-section">
        <div
          className="map-wrapper"
          onClick={handleEnableMap}
          style={{
            pointerEvents: interactive ? 'auto' : 'none',
            position: 'relative',
          }}
        >
          {!interactive && (
            <div
              className="map-overlay"
              style={{
                position: 'absolute',
                zIndex: 1000,
                width: '100%',
                height: '100%',
                cursor: 'pointer',
                background: 'transparent',
              }}
            />
          )}
          <MapContainer
            center={position}
            zoom={16}
            style={{ height: '400px', width: '100%' }}
            scrollWheelZoom={interactive}
            dragging={interactive}
            doubleClickZoom={interactive}
            zoomControl={interactive}
          >
            <TileLayer
              attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}>
              <Popup>
                71, Pillayar Kovil Street<br />
                Opp. Rajendran Hotel<br />
                Gugai, Salem - 636006
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default MapView;
